import React from "react";
import PropTypes from "prop-types";

const LeftIconHeader = ({
  imageUrl,
  imageText,
  title,
  subtitle,
  children,
  className
}) => {
  return (
    <>
      <div className={`form-header-2 ${className}`}>
        <span className={`form-header-left `}>
          {imageUrl && (
            <img className="lg_img" src={imageUrl} alt={`${imageText}-icon`} />
          )}
          <h2 className={`form-header__header ${className}`}>{title}</h2>
          <div>
            <small className="page_description">{subtitle}</small>
          </div>
        </span>
        <div>
          <span className="form-header-right">{children} </span>
        </div>
      </div>
    </>
  );
};

LeftIconHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  imageUrl: PropTypes.string,
  imageText: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string
};

export default LeftIconHeader;
